import React, { Fragment, useState } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/solid';
import EditTradeModal from './EditTradeModal';
import EditMoneyOfferModal from './EditMoneyOfferModal';

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}
const EditDropdown = ({trade, _id}) => {


    const [mode, setMode] = useState('edit');
    const setRemove = () => setMode('remove');
    const setEdit = () => setMode('edit');


    const [openModal, setOpenModal] = useState(false);
    const handleClose = () => setOpenModal(false);
    const handleEditOpen = async () =>{
        await setMode('edit');
        setOpenModal(true);
    }

    const handleRemoveOpen = async () => {
        await setMode('remove');
        setOpenModal(true);
    }

    const [openEditMoney, setOpenEditMoney] = useState(false);
    const handleMoneyClose = () => setOpenEditMoney(false);
    const handleMoneyOpen = () => setOpenEditMoney(true);

    return (
        <>
            <EditTradeModal 
                open={openModal} 
                handleClose={handleClose} 
                mode={mode} 
                trade={trade}
            />

            
            <EditMoneyOfferModal
                open={openEditMoney}
                handleClose={handleMoneyClose}
                trade={trade}
            />

            <Menu as="div" className="relative inline-block text-left z-40">
                <div>
                    <Menu.Button className="inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm ml-2 px-1 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500">
                        Edit Trade
                        <ChevronDownIcon className="-mr-1 ml-2 h-5 w-5" aria-hidden="true" />
                    </Menu.Button>
                </div>

                <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                >
                    <Menu.Items className=" absolute mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                        <div className="py-1 ">
                            { trade.sender === _id &&
                            <>
                                <Menu.Item>
                                    {({ active }) => (
                                        <button
                                            onClick={handleEditOpen}
                                            className={classNames(
                                                active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                                'block px-4 py-2 text-sm'
                                            )}
                                        >
                                            Add Item(s)
                                        </button>
                                    )}
                                </Menu.Item>
                                <Menu.Item>
                                    {({ active }) => (
                                        <button
                                            onClick={handleRemoveOpen}
                                            className={classNames(
                                                active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                                'block px-4 py-2 text-sm'
                                            )}
                                        >
                                            Remove Item(s)
                                        </button>
                                    )}
                                </Menu.Item>
                            </>
                            }
                            <Menu.Item>
                                {({ active }) => (
                                    <button
                                        onClick={handleMoneyOpen}
                                        className={classNames(
                                            active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                            'block px-4 py-2 text-sm'
                                        )}
                                    >
                                        Add/Change Money Offer
                                    </button>
                                )}
                            </Menu.Item>

                        </div>
                    </Menu.Items>
                </Transition>
            </Menu>
        </>
    );
};

export default EditDropdown;
